/**
 * Capacitor Native UI Initialization
 *
 * Configures status bar appearance and hides splash screen
 * when running in a native Capacitor shell.
 */
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'
import { SplashScreen } from '@capacitor/splash-screen'

/**
 * Initialize native UI elements. Call once at app startup.
 * No-ops on web.
 */
export async function initNativeUI(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return

  await StatusBar.setStyle({ style: Style.Light })
  // Fade out smoothly — the duration here mirrors fadeOutDuration in capacitor.config.ts.
  await SplashScreen.hide({ fadeOutDuration: 300 })
}
